import FileSaver from "file-saver";
import { injectable } from "inversify";
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(result) || result;
  return result;
};
let FileDownloadService = class {
  download({ file, title, type }) {
    FileSaver.saveAs(file, type ? `${title}.${type}` : title);
  }
};
FileDownloadService = __decorateClass([
  injectable()
], FileDownloadService);
export {
  FileDownloadService
};
//# sourceMappingURL=FileDownloadService.js.map
